export default __webpack_public_path__ + "b6524fb1ac3aee2af54ea478f7024963.svg";